import {ClosedQuestionEditor} from "./closedQuestionEditor";
import React, {Component, Fragment, h} from "preact";
import {rndStr} from "../../_common/common";
import {OpenQuestionEditor} from "./openQuestionEditor";
import {Question} from "../../_api";
import {toastService} from "../../_services/toast-service";
import {t} from "../../_i18n";


export class QuestionEditor extends Component<any, any> {

    addQuestion(type:string){
        const {onChange, value} = this.props.input;

        const answers = type == 'closed' ? [{id: '_'+rndStr(), text:"", grade: null},{id: '_'+rndStr(), text:"", grade: null},{id: '_'+rndStr(), text:"", grade: null},{id: '_'+rndStr(), text:"", grade: null},{id: '_'+rndStr(), text:"", grade: null}] : [];

        onChange([...value, {id: '_'+rndStr(), text:"", answers, type }]);
    }

    deleteQuestion(question:Question){
        toastService.showToast({message:t("La pregunta ha sido borrada"), type:'info'});
        const {onChange, value} = this.props.input;
        onChange([...value.filter((q:any)=>q!=question)]);
    }

    onChange(){
        this.props.input.onChange([...this.props.input.value]);
    }

    render({input:{value}, disabled}:any) {
        return <Fragment>
            <h3>Preguntas cerradas</h3>
            <p>Define preguntas cerradas y asigna a cada respuesta una puntuación. Para descartar automáticamente a los candidatos que no se ajusten a tus requerimientos, selecciona el valor “Descartar” como puntuación de respuesta</p>

            <ClosedQuestionEditor
                questions={value.filter((q:any)=>q.type=='closed')}
                addQuestion={()=>this.addQuestion('closed')}
                onChange={()=>this.onChange()}
                deleteQuestion={(q:Question)=>this.deleteQuestion(q)}
                disabled={disabled}
            />

            <hr className="separator-xxs"/>

            <h3>Preguntas abiertas</h3>
            <p>Estas preguntas muestran un campo abierto para que el candidato escriba la respuesta.</p>

            <OpenQuestionEditor
                onChange={()=>this.onChange()}
                questions={value.filter((q:any)=>q.type=='open')}
                addQuestion={()=>this.addQuestion('open')}
                deleteQuestion={(q:Question)=>this.deleteQuestion(q)}
                disabled={disabled}
            />

        </Fragment>
    }

}
